export default "__VITE_ASSET__d7505537__"